import axios from 'axios'
import {
  Toast
} from 'vant'
import {
  PRIVATEKEY
} from '@/common/config'
import {
  getObjKeySort
} from '@/common/tool'

var md5 = require('js-md5')

let BASE_URL = process.env.VUE_APP_ACTIVITY_BASEURL

var service = axios.create({
  baseURL: BASE_URL, // api的base_url
  timeout: 25000, // 超时时间
  retry: 3, //请求次数
  retryDelay: 1000, //请求间隙
  withCredentials: false,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
  },
})

//配置请求头
// service.defaults.headers.put['Content-Type'] = 'application/json;charset=UTF-8'

// 添加请求拦截器
service.interceptors.request.use(
  function (config) {
    // 签名封装
    var timestamp = new Date().getTime()
    var datastr = getObjKeySort(config.data).sortObjStr
    var webToken = window.localStorage&&window.localStorage.getItem('webToken');
    var signStr = ''
    if (webToken) {
      signStr = `webToken:${webToken}|time:${timestamp}|privateKey:${PRIVATEKEY}|data:${datastr}`
    } else {
      signStr = `time:${timestamp}|privateKey:${PRIVATEKEY}|data:${datastr}`
    }
    var sign = md5(signStr)

    var params = {
      time: timestamp,
      sign: sign,
      data: config.data,
    }
    if (webToken) {
      params.webToken = webToken
    }
    config.data = params
    return config
  },
  function (error) {
    Toast({
      message: '网络异常，请稍后重试!',
      duration: 1500,
      forbidClick: true,
    })
    return Promise.reject(error)
  }
)

// 添加响应拦截器
service.interceptors.response.use(
  function (response) {
    // 如果http状态码正常，则直接返回数据
    // console.log(response)
    // 如果不需要除了data之外的数据，可以直接 return response.data

    if (response && response.data) {
      return response.data
    }
  },
  function (error) {
    console.log('捕获网络错误', error)
    const status = error.response && error.response.status
    if (error.message === 'Network Error') {
      Toast({
        message: '网络连接超时',
        duration: 1500,
        forbidClick: true,
      })
      return Promise.reject(error)
    }
    if (status == 504) {
      Toast({
        message: '服务器被吃了⊙﹏⊙∥!',
        duration: 1500,
        forbidClick: true,
      })
    } else if (status == 404) {
      Toast({
        message: '请求不存在⊙﹏⊙∥!',
        duration: 1500,
        forbidClick: true,
      })
    } else if (status == 403) {
      Toast({
        message: '拒绝访问!',
        duration: 1500,
        forbidClick: true,
      })
    } else {
      // Toast({
      //   message: '未知错误!',
      //   duration: 1500,
      //   forbidClick: true,
      // })
      console.log(error);
      console.log('未知错误')
    }
    return Promise.reject(error)
  }
)

// 封装axios的get请求
export function get(url, params) {
  return new Promise((resolve, reject) => {
    service
    .get(url, params)
    .then((response) => {
      // resolve(response.data);
      resolve(response)
    })
    .catch((error) => {
      reject(error)
    })
  })
}

// 封装axios的post请求
export function post(url, params) {
  return new Promise((resolve, reject) => {
    service
    .post(url, params)
    .then((response) => {
      // resolve(response.data);
      resolve(response)
    })
    .catch((error) => {
      reject(error)
    })
  })
}

// 封装axios的put请求
export function put(url, params) {
  return new Promise((resolve, reject) => {
    service
    .put(url, params)
    .then((response) => {
      // resolve(response.data);
      resolve(response)
    })
    .catch((error) => {
      reject(error)
    })
  })
}
